import React, { useEffect, useState } from "react";
import { OmniStyleComponent } from "./omni-components";
import "../../styles/noDataComponent.css";

export const NoDataComponent = (props) => {
  // Defining the default values
  const [icon, setIcon] = useState("omni:informative:alert");
  const [heading, setHeading] = useState("");
  const [message, setMessage] = useState("");
  const [isButton, setIsButton] = useState(false);

  // Setting the default values as per the props
  useEffect(() => {
    if (props.icon) 
      setIcon(props.icon);
    if (props.heading)
      setHeading(props.heading);
    if (props.message) 
      setMessage(props.message);
    if (props.isButton)
      setIsButton(props.isButton);
    if(props.setSpinnerCount)
      props.setSpinnerCount(false);
  }, []);

  // Function to reload the page
  const refreshPage = () => {
    window.location.reload(false);
  };

  return (
    <div id="noDataContainer">
      <OmniStyleComponent>
        <div className="outerContainer">
          <div className="infoContainer">
            <omni-icon class="infoIcon is-warning" icon-id={icon}></omni-icon>
            <h3 className="infoHeader">{heading}</h3>
            <p className="infoMessage">{message}</p>
            {isButton && (
              <button className="button is-outlined" onClick={refreshPage}>
                Reload
              </button>
            )}
          </div>
        </div>
      </OmniStyleComponent>
    </div>
  );
};
